import adminRequest from '../../api/admin/request'
import router from '../../router'
import Vue from 'vue'

export const state = () => ({
  requests: [],
  totalItems: '',
  totalPages: '',
  detailRequest: {

  }
})

export const getter = {}

export const mutations = {
  LIST_REQUEST (state, slug) {
    state.requests = { ...slug }
  },
  CHANGE_TOTAL (state, slug) {
    state.totalItems = slug.total_items
    state.totalPages = slug.total_pages
  },
  CHANGE_DETAIL_REQUEST (state, slug) {
    state.detailRequest = { ...slug }
  }
}

export const actions = {
  async getRequest ({commit}, params) {
    try {
      const res = await adminRequest.getRequest(params)
      if (res.status === 200) {
        commit('LIST_REQUEST', res.data.data)
        commit('CHANGE_TOTAL', res.data.metadata)
      }
    } catch (error) {

    }
  },
  async getDetailRequest ({commit}, params) {
    try {
      const res = await adminRequest.detailRequest(params)
      if (res.status === 200) {
        commit('CHANGE_DETAIL_REQUEST', res.data.data)
      }
    } catch (error) {

    }
  },
  async deleteRequest ({commit}, params) {
    try {
      const resDelete = await adminRequest.deleteRequest(params.id)
      if (resDelete.status === 204) {
        const res = await adminRequest.getRequest({page_index: 1})
        if (res.status === 200) {
          commit('LIST_REQUEST', res.data.data)
          commit('CHANGE_TOTAL', res.data.metadata)
        }
        params.modal.hide()
      }
    } catch (error) {

    }
  },
  async createCompany ({commit}, params) {
    let vm = new Vue()
    try {
      const res = await adminRequest.createCompany(params.formData)
      if (res.status === 201) {
        const resDelete = await adminRequest.deleteRequest(params.id)
        if (resDelete.status === 204) {
          const res = await adminRequest.getRequest({page_index: 1})
          if (res.status === 200) {
            commit('LIST_REQUEST', res.data.data)
            commit('CHANGE_TOTAL', res.data.metadata)
            router.push('/admin/requests')
          }
        }
      }
    } catch (error) {
      if (typeof error.response !== 'undefined') {
        for (var x in error.response.data.error) {
          for (var y in error.response.data.error[x]) {
            vm.$toastr.e(error.response.data.error[x][y])
          }
        }
      } else { vm.$toastr.e(error) }
    }
  },
  async updateUserInquiry ({commit}, params) {
    try {
      await adminRequest.updateUserInquiry(params)
    } catch (error) {

    }
  }
}

export default {
  namespaced: true,
  state,
  getter,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/admin/request.js